export const state = () => ({
  phases: null,
  recordUuid: null,
  activePhase: 0,
  activeStep: 0,
  disableNext: false,
  disablePrevious: false,
  waitForActionFlowCompletion: false,
  bulkProcessLoading: false,
  record: {},
  stepCheckingInprogress: false,
  wizardDetailsMap: {},
  wizardOverviewMap: {}
});
